export const headerSection = {
  benefits: 'Beneficios',
  partners: 'Socios',
  setups: 'Configuraciones',
};
export const description = 'El sol es nuestra principal fuente de energía y de vida en la Tierra. Los combustibles fósiles se crearon en su día a partir de su energía, pero ahora los estamos consumiendo tan rápido que pronto nos quedaremos sin ellos. La explotación de la energía solar es el primer paso hacia la concienciación medioambiental. Y nos complace poder acompañarle en este viaje.'